export default __webpack_public_path__ + "static/media/inframail-30x30.e3b6fc4a.svg";